var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"info-holder"},[_c('div',{staticClass:"warning-icon"},[_vm._v(" ! ")]),_c('div',{staticClass:"warnings"},[_c('h5',[_vm._v("Heads up!")]),_c('h6',[_vm._v("After we verify a property, you’ll only be able to view it, you can not modify or delete anymore.")])])])])
}]

export { render, staticRenderFns }